import { BadgeDollarSign, CalendarDays, Clock3, Tags } from "lucide-react";
import { UserKpiCard } from "@/pages/users/components/UserKpiCard";
import type { CommissionMetrics } from "../commission-calculations";
import { formatMoney } from "../commission-formatters";

interface CommissionStatsGridProps {
  totalCount: number;
  filteredCount: number;
  metrics: CommissionMetrics;
}

export function CommissionStatsGrid({
  totalCount,
  filteredCount,
  metrics,
}: CommissionStatsGridProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <UserKpiCard
        label="Total commissions"
        value={String(totalCount)}
        detail={`${filteredCount} affichée${filteredCount > 1 ? "s" : ""}`}
        icon={BadgeDollarSign}
        tone="gold"
      />
      <UserKpiCard
        label="Montant total"
        value={formatMoney(metrics.total)}
        detail="Sur le filtre actif"
        icon={CalendarDays}
        tone="success"
      />
      <UserKpiCard
        label="Modifs en attente"
        value={String(metrics.pendingEdits)}
        detail="Demandes à suivre"
        icon={Clock3}
        tone={metrics.pendingEdits > 0 ? "danger" : "neutral"}
      />
      <UserKpiCard
        label="Types actifs"
        value={String(metrics.activeTypes)}
        detail={`${metrics.linkedParties} tiers liés`}
        icon={Tags}
        tone="neutral"
      />
    </div>
  );
}
